import React from "react";
import { ExclamationTriangleIcon, InformationCircleIcon, ExclamationCircleIcon, CheckCircleIcon } from "@heroicons/react/20/solid";
import { classNameFilter } from "../../utils/ComponentHelpers";
import { TextComponent } from "./TextComponent";
import { XCircleIcon } from "@heroicons/react/24/outline";
const AlertComponent = ({
  title,
  messages,
  type,
  className,
  closable,
  onCloseClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNameFilter(className, getContainerStyle(type))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, renderTypeIcon(type)), /*#__PURE__*/React.createElement("div", {
    className: "ml-3"
  }, /*#__PURE__*/React.createElement(TextComponent, {
    size: "sm",
    colorName: getTextColor(type),
    className: "font-semibold",
    customizableClass: false
  }, title), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, messages.map((message, i) => /*#__PURE__*/React.createElement(TextComponent, {
    key: i,
    size: "sm",
    colorName: getTextColor(type),
    customizableClass: false
  }, message)))), closable && /*#__PURE__*/React.createElement("div", {
    className: "absolute right-0 h-5 w-5 cursor-pointer",
    onClick: onCloseClick
  }, /*#__PURE__*/React.createElement(XCircleIcon, {
    className: classNameFilter(getIconStyle(type))
  }))));
};
const getContainerStyle = (type = null) => {
  const baseStyle = "rounded-md p-4";
  switch (type) {
    case "primary":
      return ` bg-purple-50 ${baseStyle}`;
    case "secondary":
      return ` bg-gray-50 ${baseStyle}`;
    case "danger":
      return ` bg-red-50 ${baseStyle}`;
    case "warning":
      return ` bg-yellow-50 ${baseStyle}`;
    case "success":
      return ` bg-green-50 ${baseStyle}`;
    default:
      return ` bg-purple-50 ${baseStyle}`;
  }
};
const getIconStyle = type => {
  switch (type) {
    case "danger":
      return "text-red-500";
    case "primary":
      return "text-purple-500";
    case "secondary":
      return "text-gray-500";
    case "success":
      return "text-green-500";
    case "warning":
      return "text-orange-500";
    default:
      return "text-purple-500";
  }
};
const getTextColor = (type = null) => {
  switch (type) {
    case "primary":
      return `text-purple-700`;
    case "secondary":
      return `text-gray-600`;
    case "danger":
      return `text-red-700`;
    case "warning":
      return `text-yellow-700`;
    case "success":
      return `text-green-700`;
    default:
      return `text-purple-700`;
  }
};
const renderTypeIcon = (type = null) => {
  const baseStyle = "h-5 w-5";
  switch (type) {
    case "primary":
      return /*#__PURE__*/React.createElement(InformationCircleIcon, {
        className: `text-purple-600 ${baseStyle}`
      });
    case "secondary":
      return /*#__PURE__*/React.createElement(InformationCircleIcon, {
        className: `text-gray-600 ${baseStyle}`
      });
    case "danger":
      return /*#__PURE__*/React.createElement(ExclamationCircleIcon, {
        className: `text-red-600 ${baseStyle}`
      });
    case "warning":
      return /*#__PURE__*/React.createElement(ExclamationTriangleIcon, {
        className: `text-yellow-600 ${baseStyle}`
      });
    case "success":
      return /*#__PURE__*/React.createElement(CheckCircleIcon, {
        className: `text-green-600 ${baseStyle}`
      });
    default:
      return /*#__PURE__*/React.createElement(InformationCircleIcon, {
        className: `text-purple-600 ${baseStyle}`
      });
  }
};
export { AlertComponent };